module.exports = __webpack_public_path__ + "static/img/sub_page_banner_9.41cd76c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sub_page_banner_9.jpg
// module id = PtkI
// module chunks = 0